import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  ionLogInOutline,
  ionPersonAddOutline,
  ionSettingsOutline,
} from '@ng-icons/ionicons';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { KeyCloakCustomService } from '../../../keycloak/services/key-cloak-custom-service';
import { TextSizeMap } from '../../../shared/constants/text-size-map.constant';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  imports: [NzButtonModule, NzIconModule, NgIcon, CommonModule, RouterModule],
  providers: [
    provideIcons({ ionLogInOutline, ionPersonAddOutline, ionSettingsOutline }),
  ],
})
export class TopBarComponent {
  TextSizeMap = TextSizeMap;

  keycloakCustomService = inject(KeyCloakCustomService);

  userName() {
    return this.keycloakCustomService.profile()?.username ?? '';
  }

  logout() {
    this.keycloakCustomService.logout();
  }

  getDashboardLink() {
    //  / console.log(profile);
    let profile = this.keycloakCustomService.profile();
    if (profile) {
      if (profile.isAdmin) {
        return ['/admin'];
      } else if (profile.isFleet) {
        return ['/fleet'];
      } else if (profile.isCustomer) {
        return ['/user'];
      } else if (profile.isDriver) {
        return ['/driver'];
      }
    }

    return ['/login'];
  }
}
